import { Fragment } from 'react';
import * as React from 'react';

import { SEOSnippetSeo } from '@spotahome/ui-library';

import Separator from '../components/Separator';

import FeatureBoxSection from '../components/FeatureSection/FeatureBoxSection';

import moduleCorrelations from './moduleCorrelations';
import moduleParsers from './moduleParsers';

function identity(config) {
  return config;
}

async function parseConfiguration(
  { type, config },
  locale,
  domain,
  graphqlClient,
  deviceType,
  pageData
) {
  const newConfig = await (moduleParsers[type]
    ? moduleParsers[type](config, {
        locale,
        domain,
        graphqlClient,
        deviceType,
        pageData
      })
    : config);

  return { type, config: newConfig };
}

function mustAddSeparator(i, nModules) {
  return i !== 0 && i !== nModules - 1;
}

const mustAddSeoSnippet = ({ moduleList, index }) => {
  const currentModule = moduleList[index];

  const currentModuleType = currentModule.type;

  return currentModuleType === 'HomecardsModule';
};

const mustAddFeatureBox = ({ moduleList, index, isDesktop }) => {
  const currentModule = moduleList[index];
  const nextModule = moduleList[index + 1];
  const currentModuleType = currentModule.type;
  const nextModuleType = nextModule?.type;

  if (!isDesktop) {
    return false;
  }

  return (
    (currentModuleType === 'HomecardsModule' ||
      currentModuleType === 'HeroModule') &&
    nextModuleType !== 'HomecardsModule'
  );
};

export function parseConfigurations(
  config,
  locale,
  domain,
  graphqlClient,
  deviceType,
  pageData
) {
  return config
    .map(configToParse =>
      parseConfiguration(
        configToParse,
        locale,
        domain,
        graphqlClient,
        deviceType,
        pageData
      )
    )
    .filter(identity);
}

export function loadModules(modulesConfig, seoSnippet, { isDesktop }) {
  return modulesConfig
    .filter(({ type, config }) => type && config)
    .map(({ type, config }, i, moduleList) => {
      const ModuleToLoad = moduleCorrelations[type];

      return ModuleToLoad ? (
        <React.Fragment key={`${type}_${i}`}>
          <ModuleToLoad {...config} />
          {mustAddSeoSnippet({ index: i, moduleList }) ? (
            <Fragment>
              <SEOSnippetSeo isCentered seoSnippet={seoSnippet} />
            </Fragment>
          ) : null}
          {mustAddFeatureBox({
            index: i,
            moduleList,
            isDesktop
          }) ? (
            <Fragment>
              <FeatureBoxSection />
              <Separator key="separator_feature_box" />
            </Fragment>
          ) : null}

          {mustAddSeparator(i, moduleList.length) ? (
            <Separator key={`separator_${i}`} />
          ) : null}
        </React.Fragment>
      ) : null;
    })
    .filter(identity);
}

export const findModule = (modules, moduleToFind) =>
  modules.find(module => module.type === moduleToFind);
